import i18n from "@/i18n/i18n";


const API_LOCATION = location.protocol + "//" + location.host + "/pdm_webapp";
const RESET_CACHES_BASE_URL = API_LOCATION + '/cache/reset';


const url = {
    apiLocation: API_LOCATION,
    home: API_LOCATION + '/products',

    resetRuleServiceURL: RESET_CACHES_BASE_URL + '/ruleService',
    resetProductPicsURL: RESET_CACHES_BASE_URL + '/pictures',
    resetUserMangementURL: RESET_CACHES_BASE_URL + '/userManagement',
    resetTextSystemURL: RESET_CACHES_BASE_URL + '/textSystem',
    resetProcutTreeURL: RESET_CACHES_BASE_URL + '/productTree',

    overviewURL:  API_LOCATION + '/overviewByKonfigModel',

    //overviewByKonfigModelURL: API_LOCATION + '/restoverview/overviewByKonfigModel',

    partnerNetworkURL: 'https://partnernet.mayr.de/partner_webapp/?lang=' + i18n.locale ,
    resetPasswordURL: 'https://www.mayr.com/' +i18n.locale + '/account/change-password',

    loginSuccessURL:  API_LOCATION + '/casLogin/hidden',
    loginURL:  API_LOCATION + '/casLogin/redirect?url=' + API_LOCATION + '/casLogin/hidden',
    logoutURL: API_LOCATION + '/casLogout'
};

export default url;